import { useContext, useEffect } from "react";
import { PortalContext, usePortalSettingSet } from "../../../context/portal-context";
import usePageTitle from "../../../hooks/use-page-title";
import AppUserContext from "../../../context/app-user-context";
import ROLE from "../../../modules/role";

const TITLE = "Support";
// change this parameter if we updated the docs/guide
const VERSION_GUIDE = "20251107";

export default function PageSupportIndex() {
  usePageTitle(TITLE);
  usePortalSettingSet("label_header", TITLE);
  usePortalSettingSet("is_homepage", false);
  const user = useContext(AppUserContext);
  const { setCustomText } = useContext(PortalContext);

  useEffect(() => {
    setCustomText(TITLE);
  }, []);

  return <main className="content-generic content-generic--fluid" data-comp="PageSupportIndex">
    <h1 className="fs-title">User Guide</h1>

    {user.role === ROLE.PROGRAMME_ADMIN && <p>
      <a href={`/assets/guide/SIT GROW-Pro Guide for Programme Administrators.pdf?v=${VERSION_GUIDE}`} target="_blank">
        Click here to download the GROW-Pro Guide for Programme Administrators
      </a>
    </p>}

    {user.role === ROLE.SUPERVISOR && <p>
      <a href={`/assets/guide/SIT GROW-Pro Guide for Supervisors.pdf?v=${VERSION_GUIDE}`} target="_blank">
        Click here to download the GROW-Pro Guide for Supervisors
      </a>
    </p>}

    {user.role === ROLE.STUDENT && <p>
      <a href={`/assets/guide/SIT GROW-Pro Guide for Students.pdf?v=${VERSION_GUIDE}`} target="_blank">
        Click here to download the GROW-Pro Guide for Students
      </a>
    </p>}

    <p>&nbsp;</p>

    <h1 className="fs-title">Feedback</h1>

    <p>Please contact <a href="mailto:sitgrowpro@gmail.com">sitgrowpro@gmail.com</a> to share any feedback you have regarding the GROW-Pro platform.</p>
    <p>For IWSP-related support matters, please contact your <strong style={{ textDecoration: "underline" }}>Programme's IWSP coordinator</strong>.</p>
    <p>Thank you!</p>

  </main>;
}
